import { } from '@ant-design/icons';
import { LoadingOutlined, PlusCircleFilled, DownOutlined  } from "@ant-design/icons";
import { Form, Button, Select, Card, Typography, Tag, Spin} from "antd";
import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { AddAttributes, GetAllAttributes, GetAllTermsAttributes } from "../../api/api";
import { create } from "zustand";

const { Option } = Select;

export const useAttributesStore = create((set) => ({
  list: [],
  groups: {},
  selected: [],
  options: {},
  data: {},
  setList: (list) => set({ list }),
  setData: (data) => set({ data }),
  setSelected: (selected) => set({ selected }),
  setOptions: (code, options) => set((state) => ({ options: { ...state.options, [code]: options } })),
  setGroups: (groups) => set((state) => ({ groups: { ...state.groups, ...groups } })),
  reset: () => set({ list: [], groups: {}, selected: [], options: {}, data: {} }),
}));

export const Atributes = ({ next, setcontrolStatusGeneral, controlStatusGeneral }) => {
  const attributes = useAttributesStore();
  const [form] = Form.useForm();
  const [loading, setloading] = useState(false);
  

  const fetchAttributes = async () => {
    try {
      const response = await GetAllAttributes();
      const formattedList = response.data.map((attr) => ({
        id: attr.id,
        name: attr.name,
      }));

      // Cargar los términos para cada atributo
      const termsPromises = formattedList.map(async (attr) => {
        try {
          const termsResponse = await GetAllTermsAttributes(attr.id);
          return {
            id: attr.id,
            terms: termsResponse.data || []
          };
        } catch (error) {
          console.error(`Error al cargar términos para ${attr.name}:`, error);
          return {
            id: attr.id,
            terms: []
          };
        }
      });

      const termsResults = await Promise.all(termsPromises);
      const groups = termsResults.reduce((acc, { id, terms }) => {
        acc[id] = terms;
        return acc;
      }, {});

      return {
        list: formattedList,
        groups: groups
      };
    } catch (error) {
      throw new Error("Error al cargar los atributos desde la API: " + error.message);
    }
  };

  const loadAttributes = useCallback(async () => {
    try {
      const response = await fetchAttributes();
      attributes.setList(response.list);
      attributes.setGroups(response.groups);
    } catch (error) {
      console.error("Error al cargar los atributos:", error);
      toast.error("Error al cargar los atributos: " + error.message);
    }
  }, [attributes]);

  useEffect(() => {
    if (attributes.list.length === 0) {
      loadAttributes();
    }
  }, [attributes.list, loadAttributes]);

  const getJustOptions = () => {
    const data = {};
    attributes.selected.forEach((id) => {
      if (attributes.options[id] && Array.isArray(attributes.options[id])) {
        data[id] = attributes.options[id].map((option) => {
          const term = attributes.groups[id]?.find((i) => i.id === option);
          return term ? term.name : option;
        });
      }
    });
    attributes.setData(data);
  };

  const onFinish = (values) => {
    setloading(true);

    const data = attributes.selected.map((id) => {
      if (!attributes.options[id] || !Array.isArray(attributes.options[id])) {
        return null;
      }
      const options = attributes.groups[id]
        ?.filter((option) => attributes.options[id].includes(option.id))
        .map((option) => option.name) || [];
      return { id, options, visible: true, variation: true };
    }).filter(Boolean);

    getJustOptions();

    AddAttributes({ attributes: data })
      .then((res) => {
        if (res.data.id) {
          toast.success(
            data.length === 1
              ? "Se agregó correctamente el atributo"
              : "Se agregaron correctamente los atributos"
          );
          next();
          setcontrolStatusGeneral({
            ...controlStatusGeneral,
            finish: true,
          });
        } else {
          toast.error("Error al agregar el atributo");
        }
        setloading(false);
      })
      .catch((error) => {
        toast.error("Error al agregar el atributo: " + error.message);
        setloading(false);
      });
  };

  return (
    <Card
      title={
        <Typography.Title level={4} style={{ margin: 0, color: "#1d1d1d" }}>
          Atributos y términos a utilizar
        </Typography.Title>
      }
      hoverable
      bordered={false}
      headStyle={{ borderBottom: "none", padding: "24px 24px 0" }}
      bodyStyle={{ padding: "16px 24px 24px" }}
      style={{
        width: "100%",
        maxWidth: "900px",
        borderRadius: "16px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        backgroundColor: "#ffffff"
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          name="atributos"
          label={<span style={{ fontWeight: 500, fontSize: "15px" }}>Atributos</span>}
          rules={[{ required: true, message: "Por favor selecciona al menos un atributo" }]}
        >
          <Select
            mode="multiple"
            size="large"
            placeholder={
              <span style={{ color: "#bfbfbf" }}>
                Seleccione uno o varios atributos
              </span>
            }
            maxTagCount="responsive"
            allowClear
            onChange={(values) => attributes.setSelected(values)}
            style={{ width: "100%" }}
            dropdownStyle={{ borderRadius: "8px" }}
            suffixIcon={<DownOutlined style={{ color: "#8c8c8c" }} />}
          >
            {attributes.list.length > 0 &&
              attributes.list.map((term) => (
                <Option key={term.id} value={term.id}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Tag color="blue" style={{ marginRight: 8 }}>
                      {term.name}
                    </Tag>
                  </div>
                </Option>
              ))}
          </Select>
        </Form.Item>
  
        <div style={{ margin: "24px 0", borderTop: "1px solid #f0f0f0" }} />
  
        {attributes.list.map(att => 
          !attributes.selected.includes(att.id) ? null : (
            <Form.Item
              key={att.id}
              name={att.name}
              label={<span style={{ fontWeight: 500, fontSize: "15px" }}>{att.name}</span>}
              rules={[{ required: true, message: `Por favor selecciona términos para ${att.name}` }]}
              style={{ marginBottom: "24px" }}
            >
              <Select
                mode="multiple"
                size="large"
                placeholder={
                  <span style={{ color: "#bfbfbf" }}>
                    Seleccione uno o varios términos
                  </span>
                }
                maxTagCount="responsive"
                allowClear
                onChange={(values) => attributes.setOptions(att.id, values)}
                style={{ width: "100%" }}
                dropdownStyle={{ borderRadius: "8px" }}
                suffixIcon={<DownOutlined style={{ color: "#8c8c8c" }} />}
              >
                {attributes.groups[att.id]?.map((term) => (
                  <Option key={term.id} value={term.id}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Tag color="cyan" style={{ marginRight: 8 }}>
                        {term.name}
                      </Tag>
                    </div>
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )
        )}
  
        <Form.Item style={{ textAlign: "center", marginTop: "32px" }}>
          {loading ? (
            <Spin 
              indicator={<LoadingOutlined style={{ fontSize: 32, color: "#1890ff" }} spin />}
            />
          ) : (
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              icon={<PlusCircleFilled />}
              style={{
                height: "48px",
                width: "240px",
                fontSize: "16px",
                fontWeight: 500,
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(24, 144, 255, 0.3)",
                transition: "all 0.3s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 6px 16px rgba(24, 144, 255, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(24, 144, 255, 0.3)";
              }}
            >
              Seleccionar y continuar
            </Button>
          )}
        </Form.Item>
      </Form>
    </Card>
  );  
};

export default Atributes;